// @TODO: this file is to make old stuff work as expected - eventually we should
// migrate to the new standard for headings (and use the components
// inside: src/design/components/heading/Headings.jsx)
import { Heading } from 'src/design/components/heading/Headings';


export default ({ children, ...props }) => <Heading {...props}><h1>{children}</h1></Heading>;
